import { CheckboxGroupOption } from "../../Unknown/CheckboxGroup";

type AddOn = {
  id: string;
  name: string;
  price: number;
  allowMultiplePurchases?: boolean;
};

interface ParseAddOnParams {
  addOn: AddOn;
  currencyCode: string;
  checked: boolean;
  offeringsCount: number;
  quantity?: number;
  onQuantityChange?: (quantity: number) => void;
}

const parseAddOnToCheckboxGroupOption = (
  params: ParseAddOnParams,
): CheckboxGroupOption => {
  const {
    addOn,
    offeringsCount,
    currencyCode,
    checked,
    quantity = 1,
    onQuantityChange,
  } = params;
  const total = addOn.price * offeringsCount * quantity;

  return {
    value: addOn.id,
    label: addOn.name,
    price: total,
    currencyCode,
    checked,
    allowMultiplePurchases: addOn.allowMultiplePurchases,
    quantity,
    onQuantityChange,
  };
};

export default parseAddOnToCheckboxGroupOption;
